import { Page, WpDocument } from "../types/wptypes";
import { Line, LoadState } from "../types/commontypes";
import { PgReader } from "./pgreader";

interface SearchState{
    pageIndex:number
    searchText:string
    from:number
}

export class SearchService {
    public static instance: SearchService = new SearchService()

    private reader: PgReader
    private searchText: string
    private doc: WpDocument
    private pages: Page[]

    private searchState:SearchState=Object.create(null)
    
    search(reader: PgReader, text: string) {
        this.reader = reader
        this.searchText = text
        this.doc = reader.doc
        this.pages = reader.doc.pages

        let state=this.searchState
        if(state.pageIndex==-1||!state.searchText||state.searchText!=text){
            state.pageIndex=reader.startPageIndex
            state.searchText=text
            state.from=0
        }
        
        this.searchPage(this.pages[state.pageIndex], state)

    }
    private async searchPage(page: Page, state:SearchState) {
        if(page.state!=LoadState.Ready){
            await this.reader.loadPage(page,false)
        }
        let index = page.text.indexOf(state.searchText, state.from)
        if (index != -1) {
            let lines:Line[] = page.lines, off = 0, line: Line
            let c1 = this.reader.caret1, c2 = this.reader.caret2
            for (let i = 0; i < lines.length; i++) {
                line = lines[i]
                if (off <= index && index <= off + line.chars.length) {
                    c1.line=line
                    c1.lineIndex=i
                    c1.page=page
                    c1.off=index-off
                    c1.x=line.chars[c1.off].x
                    break
                }
            }

            c2.page=c1.page
            c2.line=c1.line
            c2.lineIndex=c1.lineIndex
            c2.off=Math.min(c1.off+state.searchText.length,c1.off+c1.line.chars.length)
            c2.x=c2.line.chars[c2.off].x
            
            await this.reader.scrollIntoView(page,c1.line.y)
            this.reader.paintSelection('yellow')
            state.from=index+state.searchText.length
            // console.log('found :',state.pageIndex,state.from);
            
            return
        }
        if (page.index < this.pages.length - 1) {
            state.from=0
            state.pageIndex++
            this.searchPage(this.pages[state.pageIndex],state)
        }else{
            //reach the doc end
            console.log('已搜索至文档末尾');
            state.pageIndex=-1
            
        }
    }
}